import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE || 'http://localhost:8000';
const WS_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const ticketAPI = {
  // Get all tickets for current user
  getTickets: async () => {
    const response = await api.get('/api/list_tickets.php');
    return response.data;
  },

  // Create a new ticket
  createTicket: async (ticketData) => {
    const response = await api.post('/api/create_ticket.php', ticketData);
    return response.data;
  },

  // Get messages for a ticket (from WebSocket server)
  getMessages: async (ticketId) => {
    const response = await axios.get(`${WS_URL}/api/messages/${ticketId}`);
    return response.data;
  },

  // Get ticket status only (lightweight, fast)
  getTicketStatus: async (ticketId) => {
    const response = await axios.get(`${WS_URL}/api/ticket/${ticketId}/status`);
    return response.data;
  }
};

export default api;
